import React, { useEffect, useState } from "react";
import { Player as LottiePlayer } from "@lottiefiles/react-lottie-player";
import elephantAnimation from "./canvasRecorder/assets/anim/elephant.json";

interface SuspenseLoaderProps {
  isLoading: boolean;
  onLoadingComplete: () => void;
}

const SuspenseLoader: React.FC<SuspenseLoaderProps> = ({
  isLoading,
  onLoadingComplete,
}) => {
  const [showLoader, setShowLoader] = useState(true);
  const [minimumTimePassed, setMinimumTimePassed] = useState(false);

  useEffect(() => {
    // Ensure loader shows for at least 3 seconds
    setMinimumTimePassed(true);
    // const timer = setTimeout(() => {
    //   setMinimumTimePassed(true);
    // }, 3000);

    //return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Only hide loader when both conditions are met:
    // 1. Minimum 3 seconds have passed
    // 2. User API call is finished (isLoading is false)
    if (!isLoading && minimumTimePassed) {
      setShowLoader(false);
      onLoadingComplete();
    }
  }, [isLoading, minimumTimePassed, onLoadingComplete]);

  if (!showLoader) {
    return null;
  }

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: 8,
        position: "fixed",
        top: 0,
        left: 0,
        backgroundColor: "#f5f5f5",
        zIndex: 9999,
      }}
    >
      <>
        <LottiePlayer
          autoplay
          loop
          speed={1}
          src={elephantAnimation}
          style={{ width: 96, textAlign: "center", height: "auto" }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: 8,
          }}
        >
          <div style={{ fontSize: 18, fontWeight: 600, textAlign: "center" }}>
            Loading Recorder Studio...Don't Blink!
          </div>
          <div style={{ fontSize: 14, fontWeight: 500, textAlign: "center" }}>
            This will only take a moment.
          </div>
        </div>
      </>
    </div>
  );
};

export default SuspenseLoader;
